import { createAction } from '@reduxjs/toolkit';
import { httpRequestFactory } from '@store/common/http-request-factory';
import { HttpRequestMethod } from '@store/common/http-request-method';
import { MAIN_API } from '@store/common/path';
import { AxiosResponse } from 'axios';
import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';

import { logError } from '../../../../core/sentry';

export class SetLocation {
  static get action() {
    return createAction('SET_USER_LOCATION');
  }

  static get saga() {
    return function* (): SagaIterator {
      try {
        SetLocation.httpRequest.call(yield call(() => SetLocation.httpRequest.generator()));
      } catch (e: any) {
        logError(e);
      }
    };
  }

  static get httpRequest() {
    return httpRequestFactory<AxiosResponse<undefined>, undefined>(
      MAIN_API.SET_LOCATION,
      HttpRequestMethod.Post,
    );
  }
}
